;(function () {
    window.Ateed.Components.PageHeaderBar = function () {

        $('.article-carousel').slick({
            arrows: false,
            asNavFor: '.article-carousel-nav',
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            fade: true,
            infinite: true,
            speed: 500,
            swipe: true,
            slidesToScroll: 1,
            slidesToShow: 1
        });
        $('.article-carousel-nav').slick({
            asNavFor: '.article-carousel',
            dots: false,
            focusOnSelect: true,
            slidesToScroll: 1,
            slidesToShow: 5
        });

        $('.link-scroll').click(function () {
            $(this).toggleClass('is-active');
        })

        //
        // Drupal specific
        //
        $('h2.block-title').click(function () {
            $('.field--name-field-microsite-more-info').toggleClass('is-active');
        })
        var hasEndDate = $('.field--name-field-microsite-date-ends').length > 0;
        if (hasEndDate) {
          var dateEndsField = ' to ' + $('.field--name-field-microsite-date-ends').text();
          $('.field--name-field-microsite-date-starts').append(dateEndsField);
        }
    }
})();